<template>
  <div class="top-bar">
    <div class="container container-fluid">
      <div class="top-bar_wrap">
        <Search></Search>
        <div class="btn-group">
          <RecordButton
            v-if="!isTranscriptionRoute && showRecordButton"
          ></RecordButton>
          <ImportButton v-if="!isTranscriptionRoute"></ImportButton>
          <ShareButton v-if="isTranscriptionRoute"></ShareButton>
          <ExportButton v-if="isTranscriptionRoute"></ExportButton>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ImportButton from "@/components/top-bar/ImportButton.vue";
import ExportButton from "@/components/top-bar/ExportButton.vue";
import Search from "@/components/top-bar/Search.vue";
import ShareButton from "@/components/top-bar/ShareButton.vue";
import RecordButton from "@/components/top-bar/RecordButton.vue";
import { isRecordingEnabled } from "@/services/analytics.service";

export default {
  name: "TopBar",
  components: {
    ImportButton,
    ExportButton,
    Search,
    ShareButton,
    RecordButton,
  },
  computed: {
    isTranscriptionRoute() {
      return this.$route.path.includes("/transcription");
    },
    showRecordButton() {
      return isRecordingEnabled();
    },
  },
};
</script>
